<template>
  <div>
    <el-button class="newAdd" @click="openDialog" size="mini">新增顶级合伙人</el-button>
    <el-dialog title="新增顶级合伙人" :visible.sync="moveDialogVisible" width="40%" center @close="clear">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="UID" :label-width="formLabelWidth" prop="userId">
          <div class="search">
            <el-input v-model="form.userId" class="searchIpt" autocomplete="off"></el-input>
          </div>
        </el-form-item>

        <el-form-item label="合约返佣比例" :label-width="formLabelWidth" prop="rate">
          <el-input v-model="form.rate" class="searchIpt" maxlength="3" autocomplete="off" :disabled="disabled"
            @input="(val) => handleIntegerInput('rate', val)">
            <template slot="append">%</template></el-input>
        </el-form-item>
        <el-form-item label="现货返佣比例" :label-width="formLabelWidth" prop="spotRate">
          <el-input v-model="form.spotRate" class="searchIpt" maxlength="3" autocomplete="off"
            @input="(val) => handleIntegerInput('spotRate', val)">
            <template slot="append">%</template></el-input>
        </el-form-item>
        <el-form-item label="返佣模式" :label-width="formLabelWidth" prop="rebateType">
          <el-select v-model="form.rebateMode" placeholder="请选择返佣模式">
            <el-option v-for="item in rebateTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          label="是否为商务"
          :label-width="formLabelWidth"
          prop="isAffaires"
        >
          <el-switch
            v-model="form.isAffaires"
            active-text="是 "
            inactive-text="否"
          >
          </el-switch>
        </el-form-item> -->
        <!-- <el-form-item label="otc返佣比例" :label-width="formLabelWidth" prop="otcRate" >
        <el-input v-model="form.otcRate" class="searchIpt" autocomplete="off">
          <template slot="append">%</template></el-input>
    </el-form-item> -->
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="add">添加</el-button>
            <el-button size="mini"  @click="clear">重置</el-button>
          </span> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="clear">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { REBATE_TYPE } from '../../constants'

const validateInteger = (requiredMessage) => (rule, value, callback) => {
  if (value === '' || value === null || value === undefined) {
    if (requiredMessage) {
      callback(new Error(requiredMessage))
    } else {
      callback()
    }
    return
  }
  if (!/^\d+$/.test(String(value).trim())) {
    callback(new Error('只能输入整数'))
    return
  }
  callback()
}

export default {
  data() {
    return {
      moveDialogVisible: false,
      form: {
        rate: '',
        userId: '',
        spotRate: '',
        rebateMode: '',
        // isAffaires: false,
      },
      disabled: false,
      formLabelWidth: '140px',
      rebateTypeList: REBATE_TYPE,
      rules: {
        userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        rate: [
          { required: true, validator: validateInteger('请输入比例'), trigger: 'blur' },
        ],
        spotRate: [{ validator: validateInteger(), trigger: 'blur' }],
        otcRate: [
          { required: true, message: '请输入otc返佣比例', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    ...mapActions('partnerList', ['addTop']),
    openDialog() {
      this.moveDialogVisible = true
    },
    handleIntegerInput(field, val) {
      this.form[field] = String(val).replace(/\D/g, '')
    },
    add() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.addTop(this.form).then((res) => {
          if (res.code == 0) {
            this.$message.success('添加成功')
            this.$emit('refresh')
            this.clear()
          } else {
            this.$message.error('添加失败')
            this.clear()
          }
        })
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    clear() {
      this.moveDialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
  watch: {
    // form: {
    //   handler(val, oldVal) {
    //     if (val.isAffaires) {
    //       this.disabled = true
    //       this.form.rate = 0
    //     } else {
    //       this.disabled = false
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
}
</script>

<style lang="less" src="../../../../styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;

  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }

  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;

    .ipt {
      width: 90%;
    }
  }
}

.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
